import { ChangeEvent, useContext, useEffect, useState } from 'react'
import { JobListContext, JobStateFilters } from '@/context/jobListContext'

interface iProps {
  name: keyof JobStateFilters
  options: {
    value: string
    label: string
  }[]
  onChange: (value: string[], key: string) => void
  value: string[] | null | undefined
  className?: string
}

const Checkbox = ({ name, options, onChange, value, className }: iProps) => {
  const [selected, setSelected] = useState(value || [])
  const { state } = useContext(JobListContext)
  const filters: JobStateFilters | null = state.filters ? state.filters : null

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const currentValue = e.currentTarget.value
    let filtered = selected && [...selected]
    if (selected) {
      if (selected.includes(currentValue)) {
        filtered = filtered.filter((item: string) => item !== currentValue)
      } else {
        filtered.push(currentValue)
      }
    }
    onChange(filtered, name)
    setSelected(filtered)
  }

  useEffect(() => {
    if (filters && filters.hasOwnProperty(name)) {
      setSelected(filters[name] as string[])
    }
  }, [state])

  return (
    <div className={className}>
      <style jsx>{`
        .checkboxInput:checked + .checkboxTitle {
          background: var(--color-black, #151515);
          color: #fff;
          border-color: var(--color-black, #151515);
        }

        .checkboxInput:focus-visible + .checkboxTitle {
          outline: 2px solid #ec602b;
          outline-offset: 2px;
        }

        .checkboxInput:disabled + .checkboxTitle {
          opacity: 0.5;
        }
      `}</style>

      {options.map((item, index) => (
        <label key={index} className='relative mr-2'>
          <input
            type='checkbox'
            onChange={handleCheckboxChange}
            checked={selected && selected.includes(item.value)}
            value={item.value}
            className='absolute opacity-0 w-0 h-0 checkboxInput'
          />
          <span className='inline-block border border-gray-100 hover:bg-gray-100 rounded-full py-1 md:py-3 px-5 mb-2 cursor-pointer checkboxTitle transition-colors'>
            {item.label}
          </span>
        </label>
      ))}
    </div>
  )
}

export default Checkbox
